import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CupcakeDropdownsModule } from '@ipreo/cupcake-components';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '@ipreo/muni-shared';
import { MonitorPriorityPageComponent } from './components/tabs/monitor-priority-tab/monitor-priority-page.component';
import { MonitorRetailPageComponent } from './components/tabs/monitor-retail-tab/monitor-retail-page.component';
import { MonitorOverviewPageComponent } from './components/tabs/monitor-overview-tab/monitor-overview-page.component';
import { RadioSelectorComponent } from './components/filter-label/radio-selector/radio-selector.component';
import { FilterLabelComponent } from './components/filter-label/filter-label.component';
import { MonitorComponent } from './components/monitor/monitor.component';
import { TrancheModule } from '../tranche/Tranche.module';
import { GamedaySharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TrancheModule,
    SharedModule,
    AgGridModule,
    GamedaySharedModule,
    CupcakeDropdownsModule
  ],
  declarations: [
    MonitorComponent,
    MonitorOverviewPageComponent,
    MonitorRetailPageComponent,
    MonitorPriorityPageComponent,
    FilterLabelComponent,
    RadioSelectorComponent
  ],
  exports: [
    MonitorComponent,
    MonitorOverviewPageComponent,
    MonitorRetailPageComponent,
    MonitorPriorityPageComponent,
    FilterLabelComponent,
    RadioSelectorComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class MonitorModule {}
